import { combineReducers } from "redux";
import reportFiltersReducer from "./reportFiltersReducer";

const reducer = combineReducers({
  costsCart: '',
  staffCart: '',
  reportFilters: reportFiltersReducer
})

export default reducer;